import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: end;
  align-items: baseline;
  margin-left: auto;
  gap: 8px;
  width: 130px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Circle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;
